// extracted by mini-css-extract-plugin
export var cardIcon = "_90-5";
export var cardIconUnframed = "_90-9";
export var checkboxCard = "_90-0";
export var checkboxCardSelected = "_90-4";
export var disabled = "_90-2";
export var interactive = "_90-1";
export var outerBorder = "_90-3";
export var spacerMedium = "_90-8";
export var spacerSmall = "_90-7";
export var spacerXsmall = "_90-6";